import styled from 'styled-components'
import {THEME_COLORS} from 'common/theme/_colors'

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1300;

  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.25);
`

export const StyledMonthlyReviewModal = styled(StyledOverlay)`
  .monthly-review {
    &__container {
      position: relative;

      width: 600px;
      max-width: calc(100vw - 32px);
      max-height: calc(100vh - 32px);
      padding: 0 24px 24px;

      overflow: auto;
      background: url('/img/bg-review.png') no-repeat top center / 100% auto,
        linear-gradient(#ffffff, #ffffff) no-repeat bottom center / 100% 60%;
      border-radius: 12px;
    }

    &__close {
      position: absolute;
      top: 86px;
      right: 24px;
      z-index: 1;

      width: 20px;
      height: 20px;

      display: flex;
      align-items: center;
      justify-content: center;

      color: ${THEME_COLORS.secondary_100};

      cursor: pointer;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    &__header {
      padding-top: 118px;

      text-align: center;
    }

    &__title,
    &__subtitle {
      width: 100%;
      display: block;
    }

    &__stars {
      margin: 16px 0 24px;

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 7.75px;
    }

    &__star {
      width: 40px;
      height: 40px;
      padding: 0;

      display: flex;
      align-items: center;
      justify-content: center;

      background: none;
      border: none;

      color: #dddfe4;

      transition: color 0.2s, transform 0.2s;
      cursor: pointer;

      svg {
        width: 40px;
        height: 40px;
      }

      &[data-active='true'] {
        color: #f6c845;
      }

      &:hover {
        transform: scale(1.08);
      }
    }

    &__label {
      font-size: 14px !important;
      font-weight: 600 !important;
      color: #151624 !important;
      margin-bottom: 8px;
      display: block;
    }

    &__textarea {
      width: 100%;
      height: 100px;
      padding: 12px;

      display: block;

      background: #ffffff;
      border: 1px solid #ebeef5;
      border-radius: 8px;

      color: ${THEME_COLORS.secondary_100};
      font-family: inherit;
      font-size: 14px;
      line-height: 20px;

      outline: none;
      resize: none;
      transition: border-color 0.2s;

      &::placeholder {
        color: #7C88A6;
      }

      &:focus {
        border-color: ${THEME_COLORS.primary_300};
      }
    }

    &__footer {
      margin-top: 24px;

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      button {
        width: 110px;
        height: 32px;
        padding: 0;

        border-radius: 6px;

        font-size: 15px;
        font-weight: 600;
        line-height: 30px;

        &[data-appearance='ghost'] {
          border-color: #ebeef5;

          color: #151624;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
`

export const StyledMonthlyReviewThankYouModal = styled(StyledOverlay)`
  .monthly-review-thank-you {
    &__container {
      position: relative;

      width: 600px;
      max-width: calc(100vw - 32px);
      height: 262px;
      padding: 24px;

      display: flex;
      flex-direction: column;
      align-items: center;

      background: #ffffff;
      border-radius: 12px;
      box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1);

      text-align: center;
    }

    &__icon {
      width: 150px;
      height: 100px;

      display: block;

      object-fit: contain;
    }

    &__title {
      margin-top: 8px;
    }

    &__description {
      margin-top: 4px;
    }

    &__footer {
      margin-top: 16px;

      button {
        width: 110px;
        height: 32px;
        padding: 0;

        border-radius: 6px;

        font-size: 14px;
        font-weight: 400;
        line-height: 30px;

        &[data-appearance='ghost'] {
          border-color: #ebeef5;

          color: #151624;
        }
      }
    }
  }
`
